import { getLifecycle } from 'service/utils';

const REDUCER_NAME = 'SPORTSTEAMS';
export const SPORTS_TEAMS_ACTION = getLifecycle(REDUCER_NAME, 'SPORTS_TEAMS_ACTION');
